import { render, staticRenderFns } from "./SystemTagTreeManagement.vue?vue&type=template&id=b2424d4c"
import script from "./SystemTagTreeManagement.vue?vue&type=script&lang=js"
export * from "./SystemTagTreeManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports